module.exports = __webpack_public_path__ + "img/call_talent2.8df1e7ca.jpeg";